// It is OK to store these keys on the frontend
export const FLATFILE_PUBLISHABLE_KEY_DEV =
  "pk_d32f3a4351ff43b496dc236bd2eaf7a5";

export const FLATFILE_PUBLISHABLE_KEY_PROD =
  "pk_33ee7d2d6580454fb8632964e0ca4362";

export const ABLY_API_KEY_DEV =
  "4m7E3A._w9XuQ:t8ILkM2uMdlll-xzZue4eK5xVIT2uS6jawCR9IzE2Mc";

export const ABLY_API_KEY_STAGE =
  "IbEl8A.NdwzKQ:feoNPb9406K9-N95NmRLK4G13Bu8ds4-iYPXXwYvUF0";

export const ABLY_API_KEY_PROD =
  "w9oBdg.nmfPCw:TBXKtFzxBMGOIrONUsPN0KS33PJUCsT4sqTNQJMt-8U";

export const MEMBER_NOTIFICATION_ARTICLE_LINK =
  "https://help.pushpress.com/en/articles/10421291-member-notification-during-migration-to-pushpress-core";

export const STRIPE_DASHBOARD_URL = "https://dashboard.stripe.com/customers/";

export const DATA_NOT_AVAILABLE = "Data not available";

export const EMPTY_DATA = "—";

export const STRIPE_DATA_PULL_COMPLETED = "Stripe data pull completed";

export const PAYMENT_MATCHING_COMPLETED = "Payment matching completed";

export const getStateFullNameToAbbreviation = () => ({
  // US States
  Alabama: "AL",
  Alaska: "AK",
  Arizona: "AZ",
  Arkansas: "AR",
  California: "CA",
  Colorado: "CO",
  Connecticut: "CT",
  Delaware: "DE",
  Florida: "FL",
  Georgia: "GA",
  Hawaii: "HI",
  Idaho: "ID",
  Illinois: "IL",
  Indiana: "IN",
  Iowa: "IA",
  Kansas: "KS",
  Kentucky: "KY",
  Louisiana: "LA",
  Maine: "ME",
  Maryland: "MD",
  Massachusetts: "MA",
  Michigan: "MI",
  Minnesota: "MN",
  Mississippi: "MS",
  Missouri: "MO",
  Montana: "MT",
  Nebraska: "NE",
  Nevada: "NV",
  "New Hampshire": "NH",
  "New Jersey": "NJ",
  "New Mexico": "NM",
  "New York": "NY",
  "North Carolina": "NC",
  "North Dakota": "ND",
  Ohio: "OH",
  Oklahoma: "OK",
  Oregon: "OR",
  Pennsylvania: "PA",
  "Rhode Island": "RI",
  "South Carolina": "SC",
  "South Dakota": "SD",
  Tennessee: "TN",
  Texas: "TX",
  Utah: "UT",
  Vermont: "VT",
  Virginia: "VA",
  Washington: "WA",
  "Washington D.C.": "DC",
  "West Virginia": "WV",
  Wisconsin: "WI",
  Wyoming: "WY",
  // Canadian Provinces
  Alberta: "AB",
  "British Columbia": "BC",
  Manitoba: "MB",
  "New Brunswick": "NB",
  "Newfoundland and Labrador": "NL",
  "Nova Scotia": "NS",
  Ontario: "ON",
  "Prince Edward Island": "PE",
  Quebec: "QC",
  Saskatchewan: "SK",
  "Northwest Territories": "NT",
  Nunavut: "NU",
  Yukon: "YT",
});

export const getStateAbbreviationToFullName = () => ({
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "Washington D.C.",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
  AB: "Alberta",
  BC: "British Columbia",
  MB: "Manitoba",
  NB: "New Brunswick",
  NL: "Newfoundland and Labrador",
  NS: "Nova Scotia",
  ON: "Ontario",
  PE: "Prince Edward Island",
  QC: "Quebec",
  SK: "Saskatchewan",
  NT: "Northwest Territories",
  NU: "Nunavut",
  YT: "Yukon",
});
